import React, { Component } from "react";
import Http from "../../../Http";
import Pdf from '../../../components/pdfViewer'
import { Button, CircularProgress } from "@material-ui/core";

export default class DescargarNota extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pdfURL: null,
      mailLoading: false,
      loadingpdf: true,
      sbOpen: false,
      sbMsg: "",
      filename: "",
      loadingButton: false
    };
  }

  async componentDidMount() {
    const { nota } = this.props;
    this.setState({
        nota,
        filename: `nota_${nota.id}`,
      },
      () => {
        this.getPDF();
      }
    );
  }

  getPDF = async () => {
    const { nota } = this.state;
    const Resp = await Http.post(`nota-credito/file`, { type: "pdf", id_nota_credito: nota.id }, true, "arraybuffer");
    let response = null;
    try {
      let decodedString = String.fromCharCode.apply(null, new Uint8Array(Resp));
      response = JSON.parse(decodedString);
    } catch (error) {
      console.log(error);
    }
    if (response && response.error) {
      this.setState({
        loadingpdf: false,
        sbOpen: true,
        sbMsg: response.errMsg,
      });
    } else {
      const blob = new Blob([Resp], { type: "application/pdf" });
      this.setState({ loadingpdf: false, pdfURL: URL.createObjectURL(blob) });
    }
  };

  handledownloadPdf = () => {
    const { pdfURL, filename } = this.state;
    this.setState({ loadingButton: true });
    let namepdf = `${filename}.pdf`;
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = `${pdfURL}`;
    a.download = namepdf;
    document.body.appendChild(a);
    a.click();
    this.setState({ loadingButton: false });
  };

  handledownloadFile = async (type) => {
    const { nota, filename } = this.state;
    this.setState({ loadingButton: true });
    const Resp = await Http.post("nota-credito/file", { type, id_nota_credito: nota.id }, true, "arraybuffer");
    let response = null;
    try {
      let decodedString = String.fromCharCode.apply(null, new Uint8Array(Resp));
      response = JSON.parse(decodedString);
    } catch (error) {
      console.log(error);
    }
    if (response && response.error) {
      this.setState({
        loadingpdf: false,
        sbOpen: true,
        sbMsg: response.errMsg,
      });
    } else {
      let xmlfile = `XML_${filename}.xml`;
      const blob = new Blob([Resp], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = xmlfile;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
    this.setState({ loadingButton: false });
  };

  handleDownloadFiles = async () => {
    const { nota } = this.props;
    const Resp = await Http.post(`nota-credito/email`, 
    { id_cliente: nota.id_cliente, id_nota_credito: nota.id });
    if (!Resp.error) {
      this.setState({ sbMsg: Resp.data, sbOpen: true });
    } else {
      this.setState({ sbMsg: 'Error al enviar los correos', sbOpen: true });
    }
  };

  componentWillUnmount() {
    const { pdfURL } = this.state;
    window.URL.revokeObjectURL(pdfURL);
  }

  render() {
    const { pdfURL, loadingpdf, loadingButton } = this.state;

    return (
      <div style={{ minHeight: 300 }}>
        {loadingpdf && (
          <div className={`overlay`}>
            <CircularProgress size={200} />
          </div>
        )}
        {pdfURL && (
          <div className="pdf-viewer">
            <Pdf
              minWidth={750}
              pdfUrl={pdfURL}
            />
          </div>
        )}
        {pdfURL && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              padding: 10,
            }}
          >
            <Button variant="contained" onClick={this.handledownloadPdf} disabled={loadingButton} >
              <div style={{ marginRight: 10, padding: 0, height: 22 }} hidden={!loadingButton}>
                <CircularProgress color="secondary" size={20} />
              </div>
              Descargar PDF
            </Button>
            <Button
              variant="contained"
              onClick={() => this.handledownloadFile("xml-timbrado")}
              disabled={loadingButton} 
            >
              <div style={{ marginRight: 10, padding: 0, height: 22 }} hidden={!loadingButton}>
                <CircularProgress color="secondary" size={20} />
              </div>
              Descargar XML
            </Button>
            <Button
              variant="contained"
              onClick={() => this.handleDownloadFiles()}
            >
              Reenviar Correo
            </Button>
          </div>
        )}
      </div>
    );
  }
}
